export const ARTICLE_TYPE = 'article';
export const CATEGORY_TYPE = 'category';
export const MAX_ARTICLE_SEARCH_SIZE = 100;
